module.exports = __webpack_public_path__ + "img/mus.896330b7.svg";